<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.accessGroups')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{$ml.get('shared.definitions')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.accessGroups')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <i class="fa fa-setting"></i>
              <h3 class="box-title">
                <span>{{$ml.get('accessGroups.accessGroupList')}}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <input
                type="text"
                :placeholder="$ml.get('general.search')"
                v-model="searchText"
                class="form-control"
                autocomplete="false"
                style="margin-bottom:10px;"
              />
              <div
                v-show="accessGroupList.length > 0"
                class="table-responsive no-padding"
                style="max-height:500px; owerflow:auto;"
              >
                <table class="table table-hover">
                  <thead></thead>
                  <tbody>
                    <tr v-for="accessG in accessGroupList" :key="accessG.id" class="rows">
                      <td>{{accessG.name}}</td>
                      <td class="pull-right">
                        <button
                          type="button"
                          @click="selectAccessGroup(accessG.id)"
                          class="btn btn-primary btn-sm"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="accessGroupList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{$ml.get('accessGroups.accessGroupNotRecord')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('accessGroups.accessGroupInfo')}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button
                  v-show="authControl == 0"
                  @click="newAccessGroup()"
                  class="btn btn-sm btn-warning "
                >{{$ml.get('accessGroups.newAccessGroup')}}</button>
              </div>
            </div>
            <div class="box-body">
              <div class="row" style="margin-bottom:10px; margin-right:5px;">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>{{$ml.get('accessGroups.accessGroupName')}}</label>
                    <input v-model="accessGroup.name" type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-sm-12">
                  <span class="form-control checkbox" style="margin-bottom:10px;">
                    <label style="margin-left:20px;">
                      <input type="checkbox" :checked="accessGroup.isNewReaderAdd" />
                      {{$ml.get('accessGroups.addNewDevicesAutomatically')}}
                    </label>
                  </span>
                </div>
                <div class="col-sm-6">
                  <select @change="changeTemplate($event)" class="form-control">
                    <option
                      value="0"
                      :selected="selectedTemplate == 0"
                    >{{$ml.get('general.select')}}</option>
                    <option
                      v-for="accessGroup in accessGroupList"
                      :key="accessGroup.id"
                      :value="accessGroup.id"
                      :selected="selectedTemplate == accessGroup.id"
                    >{{accessGroup.name}}</option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <button @click="applyTemplate()" class="btn btn-primary" style="width:100%;">
                    <i class="fa fa-copy"></i>
                    {{$ml.get('accessGroups.applyTemplate')}}
                  </button>
                </div>
                <div class="col-sm-12" style="margin-top:10px;">
                  <div class="form-group">
                    <label>
                      {{$ml.get('accessGroups.authorizedDevices')}}
                      <span
                        @click="checkReaders()"
                        style="cursor:pointer; color:red;"
                        v-text="!isCheck ? $ml.get('general.selectAll') : $ml.get('general.removeAll')"
                      ></span>
                    </label>
                    <div
                      v-show="readerList.length > 0"
                      class="table-responsive no-padding"
                      :style="windowHeightSize"
                    >
                      <table class="table table-hover">
                        <tbody>
                          <tr v-for="reader in readerList" :key="reader.id">
                            <td class="checkbox">
                              <label style="margin-left:20px;">
                                <input
                                  type="checkbox"
                                  name="check"
                                  :checked="reader.check"
                                  @change="reader.check==true ? reader.check=false : reader.check=true"
                                />
                                {{reader.ipAddress}} | {{reader.readerNo}} - {{reader.name}}
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-show="readerList.length == 0" class="callout callout-info">
                      <i class="fa fa-info-circle"></i>
                      {{$ml.get('accessGroups.deviceNotRecord')}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button
                  v-show="!isNewAccessGroup && authControl == 0"
                  data-toggle="modal"
                  data-target="#modal-sil"
                  type="button"
                  style="margin: 5px; width:120px;"
                  class="btn btn-sm btn-danger "
                >{{$ml.get('general.delete')}}</button>
                <button
                  v-show="isNewAccessGroup && authControl == 0"
                  data-toggle="modal"
                  data-target="#modal-kaydet"
                  type="button"
                  style="margin: 5px; width:120px;"
                  class="btn btn-sm btn-success "
                >{{$ml.get('general.save')}}</button>
                <button
                  v-show="!isNewAccessGroup && authControl == 0"
                  data-toggle="modal"
                  data-target="#modal-guncelle"
                  type="button"
                  style="margin: 5px; width:120px;"
                  class="btn btn-sm btn-success "
                >{{$ml.get('general.update')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.update')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.accessGroup.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('accessGroups.isContinueAccessGroupUpdate')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveAccessGroup()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.save')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{this.accessGroup.name}}</p>
              <span>{{$ml.get('accessGroups.isContinueAccessGroupSave')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveAccessGroup()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.delete')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.accessGroup.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('accessGroups.isContinueAccessGroupDelete')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="deleteAccessGroup()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{$ml.get('general.delete')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      selectedTemplate: 0,
      accessGroup: {
        id: null,
        name: "",
        isNewReaderAdd: true,
        selectedReaders: []
      },
      accessGroups: [],
      isNewAccessGroup: true,
      isCheck: false,
      readers: []
    };
  },
  computed: {
    authControl() {
      return this.$store.getters.getAuthGecisYetkileri;
    },
    readerList() {
      return this.readers;
    },
    accessGroupList() {
      if (this.searchText) {
        return this.accessGroups.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(v => item.name.toUpperCase().includes(v));
        });
      } else {
        return this.accessGroups;
      }
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 530;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    checkReaders() {
      this.isCheck = !this.isCheck;
      let aList = this.readers;
      aList.forEach(doc => {
        if (doc.check == !this.isCheck) {
          doc.check = this.isCheck;
        }
      });
    },
    checkFalseReaders() {
      let aList = this.readers;
      aList.forEach(doc => {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    checkReader(id) {
      let aList = this.readers;
      aList.forEach(doc => {
        if (doc.readerId == id) {
          doc.check = true;
        }
      });
    },
    changeTemplate(event) {
      this.selectedTemplate = event.target.value;
    },
    applyTemplate() {
      if (this.selectedTemplate != 0) {
        var ac = this.accessGroupList.filter(a => {
          return a.id == this.selectedTemplate;
        });
        this.readers.forEach(reader => {
          ac[0].selectedReaders.forEach(doc => {
            if (reader.readerId == doc.id) {
              reader.check = true;
            }
          });
        });
        this.selectedTemplate = 0;
      } else {
        alertify.warning(this.$ml.get("alerts.pleaseSelect"));
        return;
      }
    },
    async getCheckReaderList() {
      let aList = this.readers;
      var selected = "";
      await aList.forEach(doc => {
        if (doc.check == true) {
          selected = selected + doc.readerId + ",";
        }
      });
      return selected;
    },
    async selectAccessGroup(id) {
      this.isLoadingDetail = true;
      await this.checkFalseReaders();
      this.isNewAccessGroup = false;
      let aList = this.accessGroups;
      await aList.forEach(doc => {
        if (doc.id == id) {
          this.accessGroup.id = doc.id;
          this.accessGroup.name = doc.name;
          this.accessGroup.isNewReaderAdd = doc.isNewReaderAdd;
          this.accessGroup.selectedReaders = doc.selectedReaders;
        }
      });
      let aList2 = this.accessGroup.selectedReaders;
      aList2.forEach(doc => {
        this.checkReader(doc.id);
      });
      this.isLoadingDetail = false;
    },
    async newAccessGroup() {
      this.isLoadingDetail = true;
      this.isNewAccessGroup = true;
      this.accessGroup.id = null;
      this.accessGroup.name = "";
      this.accessGroup.isNewReaderAdd = true;
      this.accessGroup.selectedReaders = [];
      this.isCheck = false;
      await this.checkFalseReaders();
      this.isLoadingDetail = false;
    },
    async deleteAccessGroup() {
      if (this.isNewAccessGroup) {
        alertify.warning(this.$ml.get("alerts.selectedAccessGroupNotBlank"));
      } else {
        this.isLoadingDetail = true;
        try {
          let id = this.accessGroup.id;
          const response = await this.$axios
            .delete("/AccessGroups/" + id)
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          this.getAccessGroups();
          this.newAccessGroup();
          alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
          this.isLoadingDetail = false;
        } catch (error) {
          alertify.error("Hata Oluştu : " + error);
          this.isLoadingDetail = false;
        }
      }
    },
    async saveAccessGroup() {
      if (this.accessGroup.name == "") {
        alertify.warning(this.$ml.get("alerts.accessGroupNameNotBlank"));
        return;
      }
      this.isLoadingDetail = true;
      let readers2 = await this.getCheckReaderList();
      if (this.isNewAccessGroup) {
        try {
          let accessGroup2 = this.accessGroup;
          const response = await this.$axios
            .post("/AccessGroups", {
              name: accessGroup2.name,
              isNewReaderAdd: accessGroup2.isNewReaderAdd,
              readers: readers2
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          let id = response.data.terminalYetkiGrubuId;
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getAccessGroups();
          this.selectAccessGroup(id);
          this.isNewAccessGroup = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let accessGroup2 = this.accessGroup;
          const response = await this.$axios
            .post("/AccessGroups/" + accessGroup2.id, {
              name: accessGroup2.name,
              isNewReaderAdd: accessGroup2.isNewReaderAdd,
              readers: readers2
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getAccessGroups();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getReaders() {
      try {
        this.isLoadingDetail = true;
        const readers = [];
        const response = await this.$axios
          .get("/Terminal/GetReaders")
          .then(response => {
            response.data.forEach(doc => {
              if (
                doc.doorType == 0 ||
                doc.doorType == 1 ||
                doc.doorType == 2 ||
                doc.doorType == 3 ||
                doc.doorType == 5
              ) {
                readers.push({
                  readerNo: doc.readerNo,
                  readerId: doc.readerId,
                  terminalId: doc.terminalId,
                  terminalNo: doc.terminalNo,
                  ipAddress: doc.ipAddress,
                  name: doc.name,
                  check: false
                });
              }
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.readers = readers;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingDetail = false;
      }
    },
    async getAccessGroups() {
      try {
        this.isLoading = true;
        const accessGroups = [];
        const response = await this.$axios
          .get("/AccessGroups")
          .then(response => {
            response.data.forEach(doc => {
              accessGroups.push({
                id: doc.id,
                name: doc.name,
                isNewReaderAdd: doc.isNewReaderAdd,
                selectedReaders: doc.postReaders
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.accessGroups = accessGroups;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage")
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getReaders();
    await this.getAccessGroups();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/accessGroups/AccessGroups.vue